export function init() {
  function openExternal(e) {
    e.preventDefault();
    window.open(e.target.href);
  }

  function loopOverElements(selector, cb) {
    const els = document.querySelectorAll(selector);

    [].forEach.call(els, cb);
  }

  loopOverElements("a[href^='http://']", (el) => {
    el.addEventListener('click', openExternal, false);
  });

  const href = [
    99, 111, 110, 116, 97, 99, 116, 64,
    112, 110, 101, 117, 109, 97, 116, 105,
    99, 119, 101, 98, 46, 99, 111, 109,
  ].map((num) => String.fromCharCode(num)).join('');
  const prefix = [ 109, 97, 105, 108, 116, 111, 58 ];
  const mto = prefix.map((code) => String.fromCharCode(code)).join('');
  loopOverElements('a[href^="mailto:"]', (foundEl) => {
    const el = foundEl;
    el.href = mto + href;
    el.textContent = href;
  });
}



// WEBPACK FOOTER //
// ./src/js/site.js